import { MarkButton } from '../../../components/MarkControls';
import React from 'react';
import type { DripStatus } from '../../../types';
import useDripActions from '../../../hooks/useDripActions';
type Props = {
    status: DripStatus | undefined;
    hasDraftVersion: boolean;
    draftVersionNumber?: number;
    onValidate: () => void;
    onActivate: () => void;
    onPause: () => void;
};
const ActionButton: React.FC<{
    label: string;
    onClick: () => void;
    variant?: 'primary' | 'danger' | 'default';
}> = ({ label, onClick, variant = 'default' }) => {
    return (
        <MarkButton
            type="button"
            onClick={onClick}
            variant={variant === 'primary' ? 'primary' : 'outlineSecondary'}
            tone={variant === 'danger' ? 'danger' : undefined}
            size="regular"
        >
            {label}
        </MarkButton>
    );
};
const ActionsBar: React.FC<Props> = ({
    status,
    hasDraftVersion,
    draftVersionNumber,
    onValidate,
    onActivate,
    onPause
}) => {
    const actions = useDripActions(status, hasDraftVersion);
    if (!status) return null;
    return (
        <div
            style={{
                display: 'flex',
                gap: '0.8rem',
                flexWrap: 'wrap'
            }}
        >
            {actions.canValidate && <ActionButton label="Validate" onClick={onValidate} />}
            {actions.canPause && <ActionButton label="Pause" onClick={onPause} variant="danger" />}
            {actions.canActivate && (
                <ActionButton
                    label={
                        status === 'DRAFT'
                            ? 'Activate'
                            : status === 'PAUSED'
                              ? hasDraftVersion
                                  ? `Resume + promote draft v${draftVersionNumber ?? ''}`
                                  : 'Resume'
                              : 'Promote draft'
                    }
                    onClick={onActivate}
                    variant="primary"
                />
            )}
        </div>
    );
};
export default ActionsBar;
